import {
  Table,
  TransactionDetails,
  MakeTransfer,
  RequestNewCard,
} from "src/component";
import { InstitutionProfileDCardData, Features } from "src/model";
import ApiContext from "src/provider/API/call-service";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import UserContext from "src/provider/state-manager/userProvider";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import {
  ScreenContainer,
  CustomContainer,
  AppSpan,
  AppText,
  FlexRow,
  AbsoluteContainer,
  AppLabel,
  FlexColumn,
  Switch,
  GridContainer,
  Circle,
  Icon,
  AddCardContainer,
  Button,
} from "src/style";
import helpers from "src/utils/helpers";
import { transactionColumns } from "src/utils/tableLayout";
import utility, { moneyFormat } from "src/utils/utility";
import { useContext, useEffect, useState } from "react";
import {
  IoChevronForwardOutline,
  IoChevronBackOutline,
  IoAdd,
} from "react-icons/io5";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router";
import { ReactComponent as BalanceTopIcon } from "src/assets/img/balance-card-up-icon.svg";
import { ReactComponent as BalanceBottomIcon } from "src/assets/img/balance-card-down-icon.svg";
import GreenCardBg from "src/assets/img/green-card-bg.svg";
import PurpleCardBg from "src/assets/img/purple-card-bg.svg";
import { CbpDashboardCard } from "src/component/CbpDashboardCard";
import { CbpCurrencyList } from "src/component/CbpDashboardCard/CurrencyCard";

const CBPDashboard = () => {
  const navigate = useNavigate();
  const { API } = useContext(ApiContext);
  const { user, setUserProperty } = useContext(UserContext);
  const { visibility } = useContext(VisibilityContext);
  const {
    info: { institutionData },
  } = useContext(AppInfoContext);
  const [dashboardData, setDashboardData] = useState<any>(user.dashboardData);
  const [txData, setTxData] = useState<any>(null);
  const [cardData, setCardData] = useState<any[]>([]);
  const [dataForCard, setDataForCard] =
    useState<InstitutionProfileDCardData | null>(null);
  const [acctTransactions, setAcctTransactions] = useState<any[]>([]);
  const [balanceData, setBalanceData] = useState<any>(null);
  const [accountIndex, setAccountIndex] = useState(0);
  const [isHideBalance, setIsHideBalance] = useState(false);
  const [isTxDetails, setIsTxDetails] = useState(false);
  const [isTransfer, setIsTransfer] = useState(false);
  const [isCardRequest, setIsCardRequest] = useState(false);

  const dummyAccounts = [{ balance: "1500000" }];
  const date = user.userInfo?.profileInfo
    ? helpers.splitDateTime(user.userInfo?.profileInfo?.lastLoginDate)
    : null;

  useEffect(() => {
    if (user.userInfo?.profileID) fetchDashboardData();
  }, [user.userInfo]);

  useEffect(() => {
    if (user.dashboardData?.length) handleDataUpdate(user.dashboardData);
  }, [user.dashboardData]);

  async function fetchDashboardData() {
    let response = await API.getDashboardData();
    if (response) {
      //response = dashboardInfo
      //handleDataUpdate(response)
    }
  }

  function handleDataUpdate(data: any) {
    if (data) {
      setDashboardData(data);
      setAcctTransactions(data[0].accountStatements);
      setCardData(data[0].cardDetail ? [data[0].cardDetail] : []);
      setBalanceData(data[0].accountBalance);
    }
  }

  function handleDashboardDataIndex(val: number) {
    setAccountIndex(val);
    setAcctTransactions(dashboardData[val].accountStatements);
    setCardData(
      dashboardData[val].cardDetail ? [dashboardData[val].cardDetail] : []
    );
    setBalanceData(dashboardData[val].accountBalance);
  }

  function handleTxDetails(data: any) {
    setTxData(data);
    setIsTxDetails(true);
  }

  async function handleViewAllTx() {
    await setUserProperty("recentTransactions", acctTransactions);
    navigate("/dashboard/transactions");
  }

  async function handleRequestCard() {
    const response = await API.getInstitutionInfoForCard();
    if (response) {
      setDataForCard(response);
      setIsCardRequest(true);
    }
  }

  return (
    <>
      <ScreenContainer padding="2.5" topPadding="0">
        <CustomContainer
          customRadius="28px 28px 0px 0px"
          borderColor="#EAECF0"
          minHeight="100"
          mnHUnit="%"
          bgColor="#FCFCFC"
          padding="2"
        >
          <CustomContainer>
            <AppSpan textSize="2.2" fontWeight="700">
              Cross Border payment
            </AppSpan>
          </CustomContainer>
          <FlexRow
            gap="2"
            justifyContent="space-between"
            alignItems="center"
            topMargin="2"
            borderWidth="1"
            borderColor="#EAECF0"
            radius="2"
            bgColor="#fff"
            height="30"
            rightPadding="4"
            leftPadding="4"
            className="balance-card-container"
          >
            <CbpDashboardCard accounts={dummyAccounts} />
            {/* CARDS */}
            <CbpCurrencyList />
          </FlexRow>
          <CustomContainer
            borderColor="#EAECF0"
            radius="0.8"
            topMargin="3"
            //shadow='0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)'
          >
            <FlexColumn minHeight="8" padding="2" alignItems="flex-start">
              <FlexRow justifyContent="space-between" gap="2" wrap="wrap">
                <AppText textSize="1.8" fontWeight="600" color="#101828">
                  Recent Transactions
                </AppText>
                <Button
                  width="8.5"
                  height="4"
                  bgColor="#ffffff"
                  borderColor="#D0D5DD"
                  color="#344054"
                  hoverColor="#0D968F"
                  titleSize="1.4"
                  onClick={handleViewAllTx}
                >
                  View All
                </Button>
              </FlexRow>
            </FlexColumn>
            <Table
              tableColumns={transactionColumns(
                handleTxDetails,
                institutionData?.defaultCurrency,
                isHideBalance
              )}
              tableData={acctTransactions}
              noDataText="No Transactions"
              noRadius
              customStyle
              paginationPerPage={4}
              noDataActionComponent={
                institutionData.featureIDs?.includes(
                  Features.INTER_BANK_TRANSFER
                ) ||
                institutionData.featureIDs?.includes(
                  Features.INTRA_BANK_TRANSFER
                ) ? (
                  <Button
                    width="16"
                    height="4"
                    topMargin="2"
                    borderColor="#0D968F"
                    hoverBgColor="#fff"
                    hoverColor="#0D968F"
                    titleSize="1.4"
                    onClick={() => setIsTransfer(true)}
                  >
                    <IoAdd
                      style={{ marginRight: "0.5rem", fontSize: "2rem" }}
                    />
                    Send Money
                  </Button>
                ) : null
              }
            />
          </CustomContainer>
        </CustomContainer>
      </ScreenContainer>
      {/* { (!!dashboardData?.length && !!visibility.isDashboardNotif) &&
                <Notification />
            }
            { isTxDetails &&
                <TransactionDetails
                    data={txData}
                    nuban={balanceData?.nuban}
                    close={() => setIsTxDetails(false)} 
                />
            }
            { isTransfer &&
                <MakeTransfer 
                    close={() => setIsTransfer(false)} 
                />
            }
            { isCardRequest &&
                <RequestNewCard
                    dataForCard={dataForCard}
                    close={() => setIsCardRequest(false)}
                />
            } */}
    </>
  );
};

export default CBPDashboard;
